<template lang="pug">
  Modal(ref="modal" title="Verified Reason" closable="true")
    .vaidation-message-modal-body.ssp-form-horizontal
      .center(v-if="errorStatus")
        p.bold {{ errorCode }}
        p {{ errorMessage }}
    div(slot="footer")
      button.btn.btn-default(@click="$refs.modal.cancel()") Close
</template>

<script>
import Modal from '@/components/common/Modal'

export default {
  props: ['value'],
  data: () => ({
    errorCode: null,
    errorMessage: null
  }),
  methods: {
    open(errorCode, errorMessage) {
      this.errorMessage = errorMessage
      this.errorCode = errorCode
      this.$refs.modal.open()
    }
  },
  computed: {
    errorStatus() {
      return this.errorMessage && this.errorCode
    }
  },
  components: {
    Modal
  }
}
</script>
<style lang="scss">
.vaidation-message-modal-body {
  .center {
    text-align: center;
    padding-top: 25px;
  }
  min-width: 300px;
  max-width: 600px;
  min-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/validation/validationlog/VerifiedReasonModal.vue